<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light fixed-top py-5 ps-0" id="navbar">
            <div class="container px-5 px-md-0">
                <button class="navbar-toggler px-3 py-3" data-bs-toggle="modal" data-bs-target="#categorySideBar">
                    <img width="24" src="front/assets/images/menu.png" alt="">
                </button>
                <a class=" pe-5 me-auto" href="#">
                    <img src="front/assets/images/badoom-03.png" alt="">
                </a>

                <div class="collapse navbar-collapse" id="navbarNav">

                    <ul class="navbar-nav">
                        <template v-for="(item , id) in menu" :key="id">
                            <li class="nav-item">
                                <a class="nav-link" aria-current="page" :href="item">{{ id }}</a>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    props: {
        menu: Object,
    },
}
</script>

<style scoped>

</style>
